import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

import { onForgotPasswordDispatch as dispatchSelector } from 'reduxModules/auth/dispatchers'
import '../../generic/RenderedField/styles.css'
import './styles.css'

const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

export function ForgotPassword({ onSubmit, hideGlobalNav, showGlobalNav }) {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors, isDirty }
  } = useForm()

  useEffect(() => {
    hideGlobalNav()
    return () => showGlobalNav()
  }, [hideGlobalNav, showGlobalNav])

  return (
    <div id="ForgotPassword" className="auth-page">
      <div>
        <div className="logo">
          <Link to="/">
            <img src="/global/assets/images/logo/logo-big.png" alt="Stan Winston School Of Character Arts" />
          </Link>
        </div>

        <div className="forgot-password-box auth-form-box">
          <h1>Forgot Password</h1>
          <p>
            Enter your Email address and we will send you an email with instructions
            on how to change your password
          </p>
          <form id="SignInForm" onSubmit={handleSubmit(onSubmit)}>
            <div className={classnames('field', { '-error': errors.email })}>
              <div className="field-container">
                <input
                  {...register('email', {
                    pattern: {
                      value: EMAIL_PATTERN,
                      message: 'Invalid email address.'
                    }
                  })}
                  type="email"
                  placeholder="Email"
                  aria-label="Email"
                />
                <span
                  className={`field__error${!errors.email ? ' field__error--hidden' : ''}`}
                  role="alert"
                >
                  {errors.email?.message}
                </span>
              </div>
            </div>
            <button
              type="submit"
              className="btn -wide -blue-2"
              disabled={!isDirty || isSubmitting}
            >
              Send
            </button>
          </form>

          <div className="auth-alt">
            or <Link to="/login">Sign In</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

ForgotPassword.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  hideGlobalNav: PropTypes.func.isRequired,
  showGlobalNav: PropTypes.func.isRequired
}

export default connect(
  null,
  dispatchSelector
)(ForgotPassword)
